<template>
  
  <div class="main-content">

    
    <PopupAddMissingData 
      :isVisible="isPopupVisible" 
      :extFormData="userInfo"
      @submit="handleFormSubmit" 
      @close="isPopupVisible = false" 
    />
 
    <!-- Section Content -->
    <div class="pt-100">
      <div class="row">
        <div class="col-md-12">
           <a :href="'/invite-friend'">
               <h5
              hre
              class="boxInvitePage bg-light text-uppercase mt-0 mb-10 letter-space-3"
            >
              Invita i tuoi amici e <span class="text-theme-colored">ricevi uno sconto del {{myUserData.InvitationDiscountPercentage}}%</span>
            </h5>
           </a>
        </div>
      </div>


      <div class="row">
        <div class="col-md-12 text-right" v-if="myUserData.IsAdmin">
          <a
            v-on:click="downloadExcel()"
            style="margin: 1rem"
            class="btn btn-dark btn-theme-colored btn-m"
            ><i class="fa fa-cloud-download" ></i> Payment Report</a
          >
          <a
            v-on:click="downloadExcelSubscriptions()"
            style="margin: 1rem"
            class="btn btn-dark btn-theme-colored btn-m"
            ><i class="fa fa-cloud-download" ></i> Subscribe Report</a
          >
        </div>
        <div class="col-md-12 t-a-center">
          <h1 class="title text-dark">
            Ciao {{ myUserData.Name }} {{ myUserData.Surname }}
          </h1>
        </div>
        <div class="col-md-12 t-a-center p-20" v-if="programs.length > 0">
          <h3 class="text-uppercase mt-0 mb-10 letter-space-3">
            Ecco i programmi di allenamento che hai acquistato
            <span class="text-theme-colored"
              ><br />
              entra per scoprire l'intero allenamento</span
            >
          </h3>
        </div>
        <div class="col-md-12 t-a-center p-20" v-if="programs.length == 0">
          <h3 class="text-uppercase mt-0 mb-10 letter-space-3">
            Attualmente non hai programmi attivi
            <span class="text-theme-colored"
              ><br />
              acquista un programma nell'apposita sezione</span
            >
          </h3>
        </div>
        <div class="col-md-12 t-a-center" v-if="myUserData.CanViewVideo">
          <a :href="'/videos'">
            <h3
              hre
              class="boxVideoPage bg-light text-uppercase mt-0 mb-10 letter-space-3"
            >
              Libreria esercizi 
              <span class="text-theme-colored">schede personalizzate</span>
            </h3>
          </a>
        </div>
      </div>
      <div class="container" v-if="programs">
        <div class="row p-20" id="dashboardPrograms">
          <div
            class="col-sm-4 pb-20"
            v-for="program in programs"
            :key="program.id"
          >
            <div class="owl-carousel-3col item">
              <div
                class="class-item box-hover-effect effect1 mb-md-30 bg-lighter category-item"
              >
                <a :href="'/programdetail?ID=' + program.id">
                  <div class="thumb mb-20">
                    <img
                      v-if="program.MainImage"
                      :alt="program.MainImage.alternativeText"
                      :src="baseUrl + program.MainImage.url"
                      class="img-fullwidth"
                    />
                  </div>
                  <div class="content text-left flip p-25 pt-0">
                    <h4 class="text-uppercase font-weight-800 line-bottom">
                      {{ program.Title }}
                    </h4>
                    <p>{{ program.Description }}</p>
                    <a class="btn-read-more btn-sm">SCOPRI</a>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.t-a-center {
  text-align: center;
}
#about .title.line-bottom {
  padding-bottom: 0;
  margin-bottom: 10px;
}
#about .title.line-bottom::after {
  height: 2px;
  width: 100%;
}

.boxInvitePage{
  padding: 1.5rem;
  width: 100%;
  text-align: center;
  margin: auto;
  cursor: pointer;
}

.mh-auto {
  max-height: initial !important;
}
</style>

<script>
import PopupAddMissingData from './../../components/PopupAddMissingData.vue';
import axios from "axios";
export default {
  name: "Dashboard",  components: {
    PopupAddMissingData,
},

  data() {
    return {
      isPopupVisible: false,
      userInfo: null,
      myUserData: {},
      baseUrl: process.env.VUE_APP_API_URL,
      programs: [],
    };
  },
  methods: {
    showPopup() {
      this.isPopupVisible = true;
    },
    handleFormSubmit(formData) {

      axios
            .post(process.env.VUE_APP_API_URL + "/user/setAccountInfo", formData);
    },
    SortByKey(array, key, ascending) {
      return array.sort(function (a, b) {
        var x = a[key];
        var y = b[key];
        if (ascending) {
          return x < y ? -1 : x > y ? 1 : 0;
        } else {
          return x > y ? -1 : x < y ? 1 : 0;
        }
      });
    },
    openAllVideoPage() {
      window.location.replace("./videos");
    },
    downloadExcel() {
      axios({
        url: process.env.VUE_APP_API_URL + "/report/payments",
        method: "GET",
        responseType: "blob",
      }).then((response) => {
        console.log(response);
        var fileURL = window.URL.createObjectURL(new Blob([response.data]));
        var fileLink = document.createElement("a");

        fileLink.href = fileURL;
        fileLink.setAttribute(
          "download",
          "PaymentReport-" + new Date().toReadableString() + ".xlsx"
        );
        document.body.appendChild(fileLink);

        fileLink.click();
      });
    },
    downloadExcelSubscriptions() {
      axios({
        url: process.env.VUE_APP_API_URL + "/report/subscribtion",
        method: "GET",
        responseType: "blob",
      }).then((response) => {
        console.log(response);
        var fileURL = window.URL.createObjectURL(new Blob([response.data]));
        var fileLink = document.createElement("a");

        fileLink.href = fileURL;
        fileLink.setAttribute(
          "download",
          "Subscriptions-" + new Date().toReadableString() + ".xlsx"
        );
        document.body.appendChild(fileLink);

        fileLink.click();
      });
    },
  },
  mounted() {
    axios
      .get(process.env.VUE_APP_API_URL + "/user/getinfo")
      .then((response) => {
        this.myUserData = response.data;
        console.log(response.data.CompletePrograms);
        this.programs = this.myUserData.CompletePrograms.sort(
          (a, b) => b.id - a.id
        );
      });

      axios
            .get(process.env.VUE_APP_API_URL + "/user/getAccountInfo")
            .then((response) => {
              if(response.data.userInfo != null){
              this.userInfo = response.data.userInfo;

              if (((this.userInfo.Name ?? '') == '') ||
          ((this.userInfo.Surname ?? '') == '')||
          ((this.userInfo.Address ?? '') == '')||
          ((this.userInfo.CAP ?? '') == '')||
          ((this.userInfo.City ?? '') == '')||
          ((this.userInfo.Province ?? '') == '')||
          ((this.userInfo.FiscalCode ?? '') == '')||
          ((this.userInfo.Phone ?? '') == '')) {
      this.isPopupVisible = true;
              console.log("Register data missing")
          }
            }
      });
  },
};
</script>